module.exports = __webpack_public_path__ + "img/clip_image148.a4585927.png";